import React, { Component } from 'react'
import { connect } from 'react-redux';
import { Grid, Paper } from '@material-ui/core';


class DeleteCategoryModal extends Component {

    constructor(props) {
        super(props);

        this.state = {
   
        };
    };


    render() {
        return (
            <>
               <Grid>
                    <Paper elevation={3} className="paperModalCategory" square='false' color='secondary'>
                        <Grid id='category_deletetion_modal' container justify='flex-start' alignItems='baseline' style={{ height: '100%' }} >
                            {/* Title and subtitle */}
                            <Grid item container alignItems='center' className="TitleRepairsModal">Confirm Category Deletion</Grid>
                            <Grid item container className="RepairsModalContainer">
                                <Grid item container justify='center' alignItems='center' className="subtitleMenuItemModal">
                                    <Grid item xs={10} md={12} lg={12} id='message_title'>
                                            Are you sure you want to delete this category?  
                                    </Grid>
                                </Grid>
    
                                {
                                    (this.props.category && this.props.category.count && this.props.category.count>0)?
                                    <Grid item container justify='center' alignItems='center' id='message_body' style={{fontFamily:'Gotham-Book', fontSize:'24px', color:'white', opacity:'0.56', marginBottom:'1rem'}}>
                                        <Grid item xs={10} md={12} lg={12}>
                                                            
                                            { 
                                                (this.props.category && this.props.category.count && this.props.category.count>0) && 
                                                `You currently have ${this.props.category.count} ${this.props.category.count>1?'activities':'activity'} categorized under "${this.props.category.name}" that will be placed into “Uncategorized”.`
                                            }
                                                    
                                        </Grid>
                                        
                                    </Grid>
                                    :
                                    undefined
                                }


                                    {/* Category Info */}
                                    
                                    <Grid item container justify='center' alignItems='flex-start'>
                                    {
                                        (this.props.category) &&
                                            <Grid id={`category_${this.props.category._id}`} item container className="padding5">
                                                <Grid item direction="row" spacing={0} className="menuItemBackground alingCenter">
                                                    <Grid item xs={12}>
                                                        {/* Image */}
                                                        <Grid item container className="alingCenter" 
                                                            style={{backgroundColor:(this.props.category.categoryColor)?this.props.category.categoryColor:'black', padding:'10px', borderTopLeftRadius:'16px', borderTopRightRadius:'16px', heigth:'250px'}}>
                                                            {
                                                                (this.props.category.iconUrl) ?
                                                                    <img
                                                                    height={'124px'}
                                                                    width={'168px'}
                                                                    src={this.props.category.iconUrl? this.props.category.iconUrl:''}
                                                                    alt={this.props.category.name}
                                                                    />
                                                                    :
                                                                    <Grid item className="altResidentName">{this.props.category.name}</Grid>
                                                            }
                                                        </Grid>
                                                    </Grid>
                                                    <Grid item xs={12}>
                                                        {/* Category name */}
                                                        <Grid item container className="alingLeftName" style={{padding:'20px'}}>
                                                            {
                                                                (this.props.category?.name) ?
                                                                    this.props.category.name
                                                                    :
                                                                    'N/A'
                                                            }
                                                        </Grid>
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                    }
                                    </Grid>
                                    {/* Buttons */}
                                    <Grid item container className="ModalButtonsContainer alingCenter" justify='flex-end'>
                                        <Grid item container className="alingCenter" direction='row'>
                                            <Grid item container className="MenuItemModalButtonNo alingCenter">
                                                <Grid id='cancel_repair_return_btn' item container className="alingCenter" onClick={() => this.props.close()}>
                                                    No, Exit
                                                </Grid>
                                            </Grid>
                                            <Grid item container className="MenuItemModalButtonYes alingCenter">
                                                <Grid id='cancel_repair_cancel_btn' item container className="alingCenter" onClick={()=>this.props.onDelete()}>
                                                    Yes, Delete
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Paper>
                    </Grid>
            
            </>
        )
    }
}



function mapStateToProps(state) {
    return {

    }
};

export default connect(mapStateToProps, {})(DeleteCategoryModal);

